import {EScene} from '@/types/scene.types'
import {useTracking} from '@repo/shared/Tracking/Tracking.hooks'
import {getTrackingGameMode} from '@repo/shared/Tracking/Tracking.utils'
import {useWakeLockContext} from '@repo/shared/WakeLockProvider'
import {useAtomValue} from 'jotai'
import {useEffect} from 'react'
import {useTransitionState} from 'react-transition-state'
import {Vector3} from 'three'
import {gameCodeState, gameModeState, sceneState} from '../Store/atoms'
import LobbyParty from './Lobby.party'
import LobbySinglePlayer from './Lobby.singleplayer'

export const lobbyPos = new Vector3(-162, 60, 0)

const LobbyScreen = () => {
  const {requestWakeLock} = useWakeLockContext()
  const {trackScreenEnter} = useTracking()

  const gameMode = useAtomValue(gameModeState)
  const gameCode = useAtomValue(gameCodeState)
  const scene = useAtomValue(sceneState)

  const [state, toggle] = useTransitionState({
    timeout: {
      enter: 0,
      exit: 2000, // <-- time allowed for the exit animation
    },
  })

  /**
   * If the scene is pre-lobby, toggle the transition
   */
  useEffect(() => {
    if (scene === EScene.LOBBY) {
      toggle(true)

      trackScreenEnter({
        screenIdentifier: 'lobby',
        abstractPath: '/lobby',
        meta: {
          gameCode: gameCode?.toString() ?? undefined,
          gameMode: getTrackingGameMode(gameMode),
        },
      })
    } else {
      toggle(false)
    }
  }, [scene])

  useEffect(() => {
    requestWakeLock()
  }, [requestWakeLock])

  /**
   * If the status is exited, don't render anything
   */
  if (state.status === 'exited') {
    return null
  }

  return gameMode === 'single_player' ? (
    <LobbySinglePlayer transitionStatus={state.status} />
  ) : (
    <LobbyParty />
  )
}

export default LobbyScreen
